module.exports = __webpack_public_path__ + "static/img/title-long.ca4bafe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping/title-long.svg
// module id = 4/b2
// module chunks = 0